<mat-card appearance="outlined" class="se-block">
    <mat-card-header [class.se-read-only]="readOnly" class="se-header">
        <mat-card-title class="se-title">{{ "CALIPER" | translate }}</mat-card-title>
        <button
            (click)="onClick(customMeasureButton)"
            *ngFor="let customMeasureButton of customMeasureButtons"
            [disabled]="!selectedMeasures"
            class="se-button"
            mat-button
        >
            {{ customMeasureButton.text }}
        </button>
    </mat-card-header>

    <table class="measure-table">
        <tr>
            <th scope="col">Ld</th>
            <th scope="col">A1</th>
            <th scope="col">A2</th>
            <th scope="col">&Delta;A</th>
            <th scope="col">&Delta;T</th>
            <th scope="col">HR</th>
            <th matTooltip="{{ 'DeleteAllMeasures' | translate }}" matTooltipClass="mat-tooltip-bigger" scope="col">
                <mat-icon (click)="onRemoveAll()" alt="Remove" class="row-image">delete</mat-icon>
            </th>
        </tr>
        <tr
            (click)="onSelect(measures)"
            (mouseout)="onMouseOut(measures)"
            (mouseover)="onMouseOver(measures)"
            *ngFor="let measures of measuresList"
            [class.rowactive]="measures.caliper.highlight"
            [class.rowselected]="measures.selected"
            [class.se-read-only]="readOnly"
            class="rows"
        >
            <td>{{ measures.caliper.title }}</td>
            <td>{{ measures.measures?.A1 | number: "1.2-2" }}</td>
            <td>{{ measures.measures?.A2 | number: "1.2-2" }}</td>
            <td>{{ measures.measures?.deltaA | number: "1.2-2" }}</td>
            <td>{{ measures.measures?.deltaT | number: "1.0-0" }}</td>
            <td>{{ measures.measures?.HR | number: "1.0-0" }}</td>
            <td>
                <mat-icon
                    (click)="onRemove(measures)"
                    (mouseout)="onMouseOut(measures)"
                    (mouseover)="onMouseOver(measures)"
                    alt="Remove"
                    class="row-image"
                    >delete</mat-icon
                >
            </td>
        </tr>
    </table>
</mat-card>
